import { ChevronDown, ChevronUp } from 'lucide-react'
import { ReactNode } from 'react'

interface SettingsSectionProps {
	title: string
	isExpanded: boolean
	onToggle: () => void
	hasUnsavedChanges?: boolean
	children: ReactNode
}

export function SettingsSection({ title, isExpanded, onToggle, hasUnsavedChanges, children }: SettingsSectionProps) {
	return (
		<div className={`border rounded-lg ${isExpanded ? 'border-rose-600 shadow-md' : 'border-gray-200'}`}>
			<button
				onClick={onToggle}
				className={`w-full flex items-center justify-between p-4 rounded-lg hover:bg-gray-50
					${isExpanded ? 'rounded-t-lg' : 'rounded-lg'}
					${isExpanded ? 'mb-4' : ''}
					`}
			>
				<span className="font-medium">{title}</span>
				{isExpanded ? (
					<ChevronUp className="h-5 w-5" />
				) : (
					<ChevronDown className="h-5 w-5" />
				)}
			</button>

			{!isExpanded && hasUnsavedChanges && (
				<div className="px-4 pb-3">
					<p className="text-sm text-amber-600">You have unsaved changes</p>
				</div>
			)}

			{isExpanded && (
				<div className="p-4 pt-0 space-y-4">
					{children}
				</div>
			)}
		</div>
	)
}
